import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { NotificationType } from "../../../../../../apis/networkdashboard/graphql/graphql";
import { services } from "../../../../../../app/services";
import { AvailabilityExportItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/availability-export/availability-export-item";
import { AvailabilityItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/availability/availability-item";
import { MalfunctionItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/malfunction/malfunction-item";
import { SelfServiceItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/self-service/self-service-item";
import { SendConfigItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/send-config/send-config-item";
import { ServiceDocumentationItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/service-documentation/service-documentation";
import { ShortcutMenu } from "../../../../../../components/subscription-detail/shortcut-menu/shortcut-menu";
import { ProductType } from "../../../../../../helpers/enums/productType";
import { LightPathBothSubscriptionDetails } from "../../../../../../pages/subscription-detail/types";

@Component({
  selector: "lightpath-shortcut-menu",
  templateUrl: "lightpath-shortcut-menu.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AvailabilityItem,
    AvailabilityExportItem,
    MalfunctionItem,
    SelfServiceItem,
    SendConfigItem,
    ServiceDocumentationItem,
    ShortcutMenu,
  ],
})
export class LightpathShortCutMenu {
  readonly subscription = input.required<LightPathBothSubscriptionDetails>();
  readonly activities = input.required<NotificationType[]>();
  protected readonly subscriptionId = computed(() => this.subscription().subscriptionId);
  protected readonly dirty = computed(() => this.subscription().dirty);

  protected readonly serviceDocumentationUrl = services[ProductType.LightPath].docs;
}
